import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiGatewayHelperService }from './apigateway-helper.service';

@Injectable()
export class CustomBackendLoggerService {
    
    constructor(
        private http: HttpClient,
        private apiGatewayHelperService : ApiGatewayHelperService) {  }

    logInfoToBackend(data) : Observable<any> {
        return this.http.post(this.apiGatewayHelperService.getApiGatewayPrefixUrl() + 'logger', data)
    }
}